import { useEffect, useState } from 'react';
import { updateCourse, courseIsValid } from 'Api/editPostPage';

const useFetch = courseId => {
  const [validCourse, setValidCourse] = useState();

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      courseIsValid({ id: courseId }).then(data => {
        setValidCourse(data.isValid);
      });
    }

    return () => {
      isMounted = false;
      setValidCourse({});
    };
  }, [courseId]);

  const courseUpdate = async (id, isDraft) => {
    const response = await updateCourse({ id, isDraft });

    return response;
  };

  return { courseUpdate, validCourse };
};

export default useFetch;
